import axios from '../../../../utills/axiosConfig';

export const fetchCaratages = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/caratages', { params });
  return res.data;
};

export const addCaratage = async (caratage) => {
  const res = await axios.post('/caratages', caratage);
  return res.data;
};

export const updateCaratage = async (id, caratage) => {
  const res = await axios.put(`/caratages/${id}`, caratage);
  return res.data;
};

export const deleteCaratage = async (id) => {
  const res = await axios.delete(`/caratages/${id}`);
  return res.data;
};

export const importCaratageCSV = async (formData) => {
  const { data } = await axios.post('/caratages/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 